module.exports = __webpack_public_path__ + "media/graph.7a267b2c.mp4";